import { primaryTeeth } from '../config/toothConfig';

export const isPrimaryTooth = (toothNumber: number) =>
  primaryTeeth.includes(toothNumber);
